<template>
    <header :class="{ header: true, 'menu-open': isMenuOpen }">
        <div class="header__top">
            <div class="header__container header__top-container">
                <div class="header__text">{{ settings ? settings.header_text : "" }}</div>
                <div class="header__timer timer">
                    <div class="timer__text">{{ settings ? settings.header_timer_text : "" }}</div>
                    <div class="timer__body">
                        <div class="timer__numbers">{{ formattedTime }}</div>
                        <div class="timer__subs">
                            <span>Дн.</span>
                            <span>Год.</span>
                            <span>Хв.</span>
                            <span>Сек.</span>
                        </div>
                    </div>
                </div>
                <a href="tel:+380937563496" class="header__phone _icon-phone">+38 (093) 756 34 96</a>
            </div>
        </div>

        <div class="header__body">
            <div class="header__container header__container-body">
                <button type="button" class="icon-menu" @click="toggleMenu"><span></span></button>
                <button class="header__search-btn _icon-search" @click="toggleSearch"></button>
                <NuxtLink to="/" class="header__logo">
                    <img src="../assets/img/logo.svg" alt="" />
                </NuxtLink>

                <div :class="{ header__search: true, 'search-header': true, 'search-open': isSearchOpen }" ref="searchContainer">
                    <button class="search-header__button search-header__button_close _icon-close" @click="toggleSearch"></button>
                    <button class="search-header__button _icon-search" @click="search"></button>
                    <input type="text" class="search-header__input" placeholder="Сережки з перлами та позолотою" v-model="searchQuery" @keyup.enter="search" />
                </div>

                <div class="header__actions actions-header">
                    <NuxtLink to="/wishlist" class="actions-header__link _icon-favorite"></NuxtLink>
                    <a href="#" class="actions-header__link _icon-cart" @click.prevent="openCart">
                        <span>{{ cartItemCount }}</span>
                    </a>
                </div>
            </div>
        </div>

        <div class="header__bottom">
            <div class="header__container header__container-bottom">
                <div class="header__menu menu">
                    <nav class="menu__body">
                        <button type="button" class="menu__icon icon-menu" @click="toggleMenu"><span></span></button>
                        <ul class="menu__list">
                            <li class="menu__item" v-for="category in categories" :key="category.id">
                                <NuxtLink v-if="!(category.subcategories && category.subcategories.length) || !isMobile" :to="{ name: 'catalog-categoryId', params: { categoryId: category.slug } }" @mouseover="toggleSubmenuHover(category.id)" @click="toggleMenu" class="menu__link">
                                    {{ category.title }}
                                </NuxtLink>
                                <button v-if="category.subcategories && category.subcategories.length && isMobile" @mouseover="toggleSubmenuHover(category.id)" @touchstart="toggleSubmenu(category.id)" class="menu__link">
                                    {{ category.title }}
                                </button>

                                <img v-if="category.subcategories && category.subcategories.length" class="menu-triangle" @mouseover="toggleSubmenuHover(category.id)" @touchstart="toggleSubmenu(category.id)" src="../assets/img/triangle.svg" alt="" />
                                <div class="submenu" :class="{ 'submenu--active': activeSubmenu === category.id }">
                                    <ul v-if="category.subcategories && category.subcategories.length" class="subcategories-wrapper">
                                        <li v-for="subcategory in category.subcategories" :key="subcategory.id">
                                            <NuxtLink
                                                v-if="subcategory.id !== 22"
                                                :to="{
                                                    name: 'catalog-categoryId-subCategorySlug',
                                                    params: {
                                                        categoryId: category.slug,
                                                        subCategorySlug: subcategory.slug,
                                                    },
                                                }"
                                                @click="toggleMenu"
                                                class="menu__link"
                                            >
                                                {{ subcategory.title }}
                                            </NuxtLink>
                                        </li>
                                        <li>
                                            <NuxtLink :to="{ name: 'catalog-categoryId', params: { categoryId: category.slug } }" @click="toggleMenu" class="menu__link"> Всі вироби </NuxtLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="menu__item">
                                <NuxtLink :to="{ name: 'Certificate' }" @click="toggleMenu" class="menu__link">Сертифікати</NuxtLink>
                            </li>
                            <li class="menu__item menu__item_hide">
                                <a href="tel:+380937563496" class="menu__link _icon-phone">+38 (093) 756 34 96</a>
                                <span>(з 10:00 -18:30)</span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div class="header__menu menu header-menu-horizontal">
            <ul class="menu__list">
                <li class="menu__item" v-for="category in categories" :key="category.id">
                    <NuxtLink :to="{ name: 'catalog-categoryId', params: { categoryId: category.slug } }" @mouseover="toggleSubmenuHover(category.id)" class="menu__link">
                        {{ category.title }}
                    </NuxtLink>
                </li>

                <li class="menu__item">
                    <NuxtLink :to="{ name: 'Certificate' }" class="menu__link">Сертифікати</NuxtLink>
                </li>
            </ul>
        </div>

        <CartPopup :show="isCartOpen" @close="closeCart" />
        <RoulettePopup />
    </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import { useCartStore } from "@/stores/cart";
import RoulettePopup from "./RoulettePopup.vue";
import { set } from "~/node_modules/nuxt/dist/app/compat/capi";

const globalStore = useGlobalStore();
const cartStore = useCartStore();

const isCartOpen = computed(() => globalStore.isCartOpen);
const cartItemCount = computed(() => cartStore.cartItemCount);
const settings = computed(() => globalStore.settings);

const { toggleCart, openCart, closeCart, fetchSettings } = globalStore;

const config = useRuntimeConfig();
const apiUrl = config.public.apiUrl;

const router = useRouter();
const isMenuOpen = ref(false);
const isPopupCartOpen = ref(false);
const isSearchOpen = ref(false);
const remainingTime = ref((typeof window !== "undefined" && localStorage.getItem("remainingTime")) || 28800);
const dataModal = ref(false);
const activeSubmenu = ref(null);
const endTime = ref();
const timerInterval = ref(null);
const bodyLockStatus = ref(true);
const searchQuery = ref("");

// Загрузка категорий с поддержкой SSR
const { data: categories } = await useFetch(`${apiUrl}categories`, {
    key: "header-categories", // уникальный ключ для кеширования
    transform: (response) => response.data || [],
    default: () => [], // значение по умолчанию
    immediate: true, // немедленно выполнить запрос
});

const formattedTime = computed(() => {
    const days = Math.floor(remainingTime.value / 86400);
    const hours = Math.floor((remainingTime.value % 86400) / 3600);
    const minutes = Math.floor((remainingTime.value % 3600) / 60);
    const seconds = remainingTime.value % 60;

    return `${formatDigits(days)}:${formatDigits(hours)}:${formatDigits(minutes)}:${formatDigits(seconds)}`;
});

const isMobile = computed(() => {
    if (process.client) {
        return window.innerWidth <= 768;
    }
    return false; // На сервере считаем, что это не мобильное устройство
});

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
    bodyLockToggle();
};

const toggleSearch = () => {
    isSearchOpen.value = !isSearchOpen.value;
};

const search = () => {
    if (searchQuery.value.trim() !== "") {
        router.push("/search?q=" + searchQuery.value);
        searchQuery.value = "";
    }
};

const toggleSubmenuHover = (id) => {
    if (window.innerWidth > 768) {
        activeSubmenu.value = activeSubmenu.value === id ? null : id;
    }
};

const toggleSubmenu = (id) => {
    activeSubmenu.value = activeSubmenu.value === id ? null : id;
};

const bodyLockToggle = (delay = 500) => {
    if (document.documentElement.classList.contains("lock")) {
        bodyUnlock(delay);
    } else {
        bodyLock(delay);
    }
};

const bodyUnlock = (delay = 500) => {
    const body = document.querySelector("body");
    if (bodyLockStatus.value) {
        const lockPadding = document.querySelectorAll("[data-lp]");
        setTimeout(() => {
            lockPadding.forEach((el) => {
                el.style.paddingRight = "0px";
            });
            body.style.paddingRight = "0px";
            document.documentElement.classList.remove("lock");
        }, delay);
        bodyLockStatus.value = false;
        setTimeout(() => {
            bodyLockStatus.value = true;
        }, delay);
    }
};

const bodyLock = (delay = 500) => {
    const body = document.querySelector("body");
    if (bodyLockStatus.value) {
        const lockPadding = document.querySelectorAll("[data-lp]");
        lockPadding.forEach((el) => {
            el.style.paddingRight = `${window.innerWidth - document.querySelector(".wrapper").offsetWidth}px`;
        });
        body.style.paddingRight = `${window.innerWidth - document.querySelector(".wrapper").offsetWidth}px`;

        bodyLockStatus.value = false;
        setTimeout(() => {
            bodyLockStatus.value = true;
        }, delay);
    }
};

const menuInit = () => {
    if (document.querySelector(".icon-menu")) {
        document.addEventListener("click", (e) => {
            if (bodyLockStatus.value && e.target.closest(".icon-menu")) {
                bodyLockToggle();
                document.documentElement.classList.toggle("menu-open");
            }
        });
    }
};

const handleClickOutside = (event) => {
    const searchContainer = document.querySelector(".header__search");
    if (searchContainer && !searchContainer.contains(event.target) && !event.target.closest(".header__search-btn")) {
        isSearchOpen.value = false;
    }
};

const formatDigits = (number) => {
    return String(number).padStart(2, "0");
};

const calculateNextMidnight = () => {
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return nextMidnight;
};

const calculateRemainingTime = () => {
    const now = new Date();
    const end = calculateNextMidnight();
    remainingTime.value = Math.floor((end - now) / 1000);

    if (remainingTime.value <= 0) {
        endTime.value = calculateNextMidnight();
        remainingTime.value = Math.floor((endTime.value - now) / 1000);
    }

    // Сохраняем только на клиенте
    if (process.client) {
        localStorage.setItem("remainingTime", remainingTime.value);
    }
};

onMounted(() => {
    menuInit();
    document.addEventListener("click", handleClickOutside);

    if (process.client) {
        timerInterval.value = setInterval(calculateRemainingTime, 1000);
        localStorage.setItem("remainingTime", remainingTime.value);
    }

    // Удаляем вызов getCategories, так как категории уже загружены через useFetch
    fetchSettings();
});

onUnmounted(() => {
    if (timerInterval.value) {
        clearInterval(timerInterval.value);
    }
    document.removeEventListener("click", handleClickOutside);
});
</script>

<style lang="scss" scoped>
.menu__item {
    display: flex;
    position: relative;
}
.menu-triangle {
    transform: rotate(59deg);
    width: 7px;
    transition: transform 0.3s;

    @media (max-width: 768px) {
        width: 10px;
    }
}
.submenu ul {
    padding: 10px;
}

@media (min-width: 768px) {
    .submenu ul {
        display: none; /* По умолчанию вложенный список скрыт */
        position: absolute;
        z-index: 9;
        background: #fff;
        left: -10px;
        top: 20px;
    }
    .menu__item:hover .submenu ul {
        display: block; /* При наведении на пункт меню вложенный список становится видимым */
    }
    .menu__item:hover .menu-triangle {
        transform: rotate(-120deg);
    }
    .menu__item_hide {
        display: none;
    }

    .subcategories-wrapper {
        width: 120px;
    }
}

@media (max-width: 768px) {
    .submenu {
        width: 100%;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 0.3s, opacity 0.3s;
    }

    .menu__item {
        flex-wrap: wrap;
    }
}

.submenu--active {
    max-height: 350px; /* Выставьте нужную высоту */
    opacity: 1;
}
</style>
